export default __webpack_public_path__ + "static/media/stress.ecd2a46c.svg";